(function () {
  'use strict';

  var HERO_SUCCESS =
    '✓ Check your inbox — your guide and $20 discount are on their way!';
  var PRICING_SUCCESS =
    '✓ Check your inbox — your guide and discount code are on their way!';
  var CAPTURE_SUCCESS =
    '✓ Check your inbox — your guide and $20 discount are on their way!';

  var EMAIL_STORAGE = {
    submitted: 'jx-email-capture-submitted',
    exitDismissed: 'jx-email-exit-dismissed',
    scrollDismissed: 'jx-email-scroll-dismissed',
  };

  function readStorage(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function writeStorage(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      /* ignore */
    }
  }

  function sanitizeNewsletterForms() {
    document.querySelectorAll('form[data-jx-newsletter-form]').forEach(function (form) {
      form.setAttribute('action', '/contact');
      form.removeAttribute('id');
      form.removeAttribute('target');
    });
  }

  function showMessage(msgId, formKey, customText, isError) {
    var msg = document.getElementById(msgId);
    var form = document.querySelector('[data-jx-newsletter-form="' + formKey + '"]');
    if (!msg) return;
    msg.classList.remove('hidden');
    if (customText) {
      msg.textContent = customText;
    } else if (formKey === 'pricing') {
      msg.textContent = PRICING_SUCCESS;
    } else if (formKey === 'exit' || formKey === 'scroll') {
      msg.textContent = CAPTURE_SUCCESS;
    } else {
      msg.textContent = HERO_SUCCESS;
    }
    msg.style.color = isError ? 'oklch(0.55 0.12 25)' : 'oklch(0.78 0.145 72)';
    if (form && !isError && (!customText || customText.indexOf('✓') === 0)) form.reset();
  }

  function disableSmoothScrollTemporarily() {
    document.documentElement.classList.add('jx-no-smooth-scroll');
    document.documentElement.style.scrollBehavior = 'auto';
  }

  function handleNewsletterRedirect() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('customer_posted') !== 'true') return;

    disableSmoothScrollTemporarily();

    var formTag = params.get('form');
    var scrollTarget = null;

    if (formTag === 'pricing') {
      showMessage('pricing-email-msg', 'pricing');
      scrollTarget = document.getElementById('email-offer') || document.getElementById('pricing-email-msg');
    } else if (formTag === 'hero') {
      showMessage('hero-email-msg', 'hero');
      scrollTarget = document.getElementById('hero-email') || document.getElementById('hero-email-msg');
    } else if (formTag === 'exit') {
      showMessage('exit-email-msg', 'exit');
      markEmailCaptureSubmitted();
      closeExitModal();
    } else if (formTag === 'scroll') {
      showMessage('scroll-email-msg', 'scroll');
      markEmailCaptureSubmitted();
      hideScrollBar(true);
    } else if (window.location.hash === '#order' || window.location.hash === '#subscribe') {
      showMessage('pricing-email-msg', 'pricing');
      scrollTarget = document.getElementById('email-offer');
    } else {
      showMessage('hero-email-msg', 'hero');
    }

    if (scrollTarget && scrollTarget.scrollIntoView) {
      scrollTarget.scrollIntoView({ behavior: 'auto', block: 'center' });
    }

    if (window.history.replaceState) {
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }

  function bindNewsletterForm(formKey, msgId, btnId, defaultBtnText) {
    var form = document.querySelector('[data-jx-newsletter-form="' + formKey + '"]');
    if (!form) return;

    form.setAttribute('action', '/contact');
    form.setAttribute('method', 'post');
    form.removeAttribute('id');
    form.removeAttribute('target');

    // Native Shopify submit only — AJAX breaks captcha ("invalid parameters")
    form.addEventListener('submit', function () {
      disableSmoothScrollTemporarily();
      try {
        sessionStorage.setItem('jx-email-no-smooth', '1');
      } catch (e) {
        /* ignore */
      }
    });
  }

  function markEmailCaptureSubmitted() {
    writeStorage(EMAIL_STORAGE.submitted, '1');
  }

  function emailCaptureBlocked() {
    return readStorage(EMAIL_STORAGE.submitted) === '1';
  }

  function getScrollRatio() {
    var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    if (maxScroll <= 0) return 0;
    return window.scrollY / maxScroll;
  }

  function isNearEmailOffer() {
    var offer = document.getElementById('email-offer');
    if (!offer) return getScrollRatio() >= 0.82;
    var rect = offer.getBoundingClientRect();
    return rect.top < window.innerHeight * 0.55;
  }

  var exitModalOpen = false;

  function openExitModal(modal) {
    if (!modal || exitModalOpen || emailCaptureBlocked()) return;
    exitModalOpen = true;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    var input = document.getElementById('exit-email-input');
    if (input) window.setTimeout(function () { input.focus(); }, 120);
  }

  function closeExitModal() {
    var modal = document.getElementById('jx-email-exit-modal');
    if (!modal) return;
    exitModalOpen = false;
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  function hideScrollBar(persist) {
    var bar = document.getElementById('jx-email-scroll-bar');
    if (!bar) return;
    bar.hidden = true;
    bar.classList.remove('is-visible');
    bar.setAttribute('aria-hidden', 'true');
    if (persist) writeStorage(EMAIL_STORAGE.scrollDismissed, '1');
  }

  function showScrollBar(bar) {
    if (!bar || emailCaptureBlocked()) return;
    if (readStorage(EMAIL_STORAGE.scrollDismissed) === '1') return;
    if (isNearEmailOffer()) return;
    bar.hidden = false;
    bar.classList.add('is-visible');
    bar.setAttribute('aria-hidden', 'false');
    updateEmailBarOffset();
  }

  function updateEmailBarOffset() {
    var bar = document.getElementById('jx-email-scroll-bar');
    var sticky = document.getElementById('jx-sticky-cta');
    if (!bar || bar.hidden) return;
    if (window.innerWidth >= 768) {
      bar.style.bottom = '';
      return;
    }
    var stickyVisible = sticky && !sticky.hidden;
    bar.style.bottom = stickyVisible ? sticky.offsetHeight + 'px' : '';
  }

  function initEmailCaptureWidgets() {
    var root = document.getElementById('jx-email-capture-root');
    if (!root) return;

    root.hidden = false;

    var exitEnabled = root.getAttribute('data-exit-enabled') === 'true';
    var scrollEnabled = root.getAttribute('data-scroll-enabled') === 'true';
    var scrollDepth = parseInt(root.getAttribute('data-scroll-depth'), 10) / 100;
    if (!scrollDepth || scrollDepth < 0.4) scrollDepth = 0.6;

    var exitModal = document.getElementById('jx-email-exit-modal');
    var scrollBar = document.getElementById('jx-email-scroll-bar');
    var exitArmed = false;
    var exitShown = false;
    var pageReadyAt = Date.now();

    bindNewsletterForm('exit', 'exit-email-msg', 'exit-email-btn', 'SEND MY FREE GUIDE + $20 OFF');
    bindNewsletterForm('scroll', 'scroll-email-msg', 'scroll-email-btn', 'SEND MY FREE GUIDE + $20 OFF');
    sanitizeNewsletterForms();

    root.querySelectorAll('[data-jx-email-dismiss]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-jx-email-dismiss');
        if (target === 'exit') {
          writeStorage(EMAIL_STORAGE.exitDismissed, '1');
          closeExitModal();
        } else if (target === 'scroll') {
          hideScrollBar(true);
        }
      });
    });

    if (exitModal) {
      exitModal.addEventListener('click', function (event) {
        if (event.target === exitModal) {
          writeStorage(EMAIL_STORAGE.exitDismissed, '1');
          closeExitModal();
        }
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && exitModalOpen) {
        writeStorage(EMAIL_STORAGE.exitDismissed, '1');
        closeExitModal();
      }
    });

    window.setTimeout(function () {
      if (!emailCaptureBlocked() && readStorage(EMAIL_STORAGE.exitDismissed) !== '1') {
        exitArmed = true;
      }
    }, 8000);

    if (exitEnabled && exitModal) {
      document.documentElement.addEventListener('mouseleave', function (event) {
        if (!exitArmed || exitShown || emailCaptureBlocked()) return;
        if (readStorage(EMAIL_STORAGE.exitDismissed) === '1') return;
        if (window.innerWidth < 768) return;
        if (Date.now() - pageReadyAt < 8000) return;
        if (isNearEmailOffer()) return;
        if (getScrollRatio() > 0.75) return;

        var y = event.clientY;
        if (typeof y === 'number' && y <= 12) {
          exitShown = true;
          openExitModal(exitModal);
        }
      });
    }

    function onScrollCapture() {
      if (scrollBar && scrollEnabled && !emailCaptureBlocked()) {
        if (getScrollRatio() >= scrollDepth) {
          showScrollBar(scrollBar);
        } else if (!scrollBar.hidden && getScrollRatio() < scrollDepth - 0.08) {
          hideScrollBar(false);
        }
        if (!scrollBar.hidden && isNearEmailOffer()) {
          hideScrollBar(false);
        }
      }
      updateEmailBarOffset();
    }

    onScrollCapture();
    window.addEventListener('scroll', onScrollCapture, { passive: true });
    window.addEventListener('resize', onScrollCapture);
  }

  document.addEventListener('DOMContentLoaded', function () {
    sanitizeNewsletterForms();
    handleNewsletterRedirect();
    bindNewsletterForm(
      'hero',
      'hero-email-msg',
      'hero-email-btn',
      'Send Me the Guide →'
    );
    bindNewsletterForm(
      'pricing',
      'pricing-email-msg',
      'pricing-email-btn',
      'SEND MY FREE GUIDE + $20 OFF'
    );

    var sticky = document.getElementById('jx-sticky-cta');
    if (sticky) {
      var showSticky = function () {
        var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
        var scrolledEnough = maxScroll <= 0 || window.scrollY >= maxScroll * 0.1;
        var nearFooter =
          document.body.scrollHeight - window.scrollY - window.innerHeight < 120;
        var shouldShow = scrolledEnough && !nearFooter;
        sticky.hidden = !shouldShow;
        sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      };
      showSticky();
      window.addEventListener('scroll', showSticky, { passive: true });
      window.addEventListener('resize', showSticky);
      window.addEventListener('scroll', updateEmailBarOffset, { passive: true });
      window.addEventListener('resize', updateEmailBarOffset);
    }

    initEmailCaptureWidgets();

    initProductGallery();
    initProductVariantSelect();
    initDirectCheckout();
  });

  function initDirectCheckout() {
    disableRechargeCartDrawer();
    watchRechargeCartOverlay();
  }

  function goToCheckout(url) {
    if (window.jxGoToCheckout) {
      window.jxGoToCheckout(url);
      return;
    }

    if (!url) return;
    window.location.href = url;
  }

  function addToCartAndCheckout(variantId, quantity, sellingPlan) {
    if (window.jxBuyNow) {
      window.jxBuyNow(variantId, quantity, sellingPlan);
      return;
    }
  }

  function watchRechargeCartOverlay() {
    var root = document.getElementById('recharge-storefront-experiences');
    if (!root || root.dataset.jxOverlayWatch === 'true') return;
    root.dataset.jxOverlayWatch = 'true';

    var hideOverlay = function () {
      root.querySelectorAll('[class*="cart-drawer"], [class*="CartDrawer"], [class*="cart-overlay"], [class*="CartOverlay"]').forEach(function (node) {
        node.style.setProperty('display', 'none', 'important');
        node.style.setProperty('visibility', 'hidden', 'important');
        node.style.setProperty('pointer-events', 'none', 'important');
        node.setAttribute('aria-hidden', 'true');
      });
    };

    hideOverlay();
    new MutationObserver(hideOverlay).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
    });
  }

  function disableRechargeCartDrawer() {
    if (!document.getElementById('jx-disable-cart-drawer-style')) {
      var style = document.createElement('style');
      style.id = 'jx-disable-cart-drawer-style';
      style.textContent =
        '#recharge-storefront-experiences [class*="cart-drawer"],' +
        '#recharge-storefront-experiences [class*="CartDrawer"],' +
        '#recharge-storefront-experiences [class*="cart-overlay"],' +
        '#recharge-storefront-experiences [class*="CartOverlay"],' +
        '#recharge-storefront-experiences cart-drawer,' +
        '.recharge-cart-drawer,' +
        '[data-recharge-cart-drawer],' +
        '[data-recharge-cart-overlay]{' +
        'display:none!important;visibility:hidden!important;pointer-events:none!important;opacity:0!important;' +
        '}';
      document.head.appendChild(style);
    }

    if (window.RechargeStorefrontConfig) {
      window.RechargeStorefrontConfig.cart_overlay = Object.assign(
        {},
        window.RechargeStorefrontConfig.cart_overlay,
        { enabled: false }
      );
      window.RechargeStorefrontConfig.cart_drawer = Object.assign(
        {},
        window.RechargeStorefrontConfig.cart_drawer,
        { enabled: false }
      );
    }
  }

  function initProductGallery() {
    var gallery = document.querySelector('[data-jx-product-gallery]');
    if (!gallery) return;

    var mainImage = document.getElementById('jx-product-main-image');
    var thumbs = gallery.querySelectorAll('[data-jx-gallery-thumb]');
    var scrollEl = gallery.querySelector('[data-jx-gallery-scroll]');
    var prevBtn = gallery.querySelector('[data-jx-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-jx-gallery-next]');
    var fadeLeft = gallery.querySelector('[data-jx-gallery-fade-left]');
    var fadeRight = gallery.querySelector('[data-jx-gallery-fade-right]');

    if (!mainImage || !thumbs.length) return;

    function setActiveThumb(thumb) {
      thumbs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-selected', 'true');

      if (scrollEl && thumb.scrollIntoView) {
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    function swapImage(src, alt, imageId) {
      if (!src) return;
      var currentId = mainImage.getAttribute('data-active-image-id');
      if (imageId && String(currentId) === String(imageId)) return;

      mainImage.classList.add('is-fading');
      window.setTimeout(function () {
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = src;
        if (alt) mainImage.alt = alt;
        if (imageId) mainImage.setAttribute('data-active-image-id', imageId);
        mainImage.classList.remove('is-fading');
      }, 120);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        swapImage(
          thumb.getAttribute('data-image-src'),
          thumb.getAttribute('data-image-alt'),
          thumb.getAttribute('data-image-id')
        );
        setActiveThumb(thumb);
      });
    });

    function updateThumbNav() {
      if (!scrollEl) return;

      var maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;
      var canScroll = maxScroll > 4;
      var atStart = scrollEl.scrollLeft <= 4;
      var atEnd = scrollEl.scrollLeft >= maxScroll - 4;

      if (prevBtn) {
        prevBtn.hidden = !canScroll;
        prevBtn.disabled = atStart;
      }
      if (nextBtn) {
        nextBtn.hidden = !canScroll;
        nextBtn.disabled = atEnd;
      }
      if (fadeLeft) fadeLeft.hidden = !canScroll || atStart;
      if (fadeRight) fadeRight.hidden = !canScroll || atEnd;
    }

    function scrollThumbs(direction) {
      if (!scrollEl) return;
      scrollEl.scrollBy({ left: direction * scrollEl.clientWidth * 0.75, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollThumbs(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollThumbs(1); });
    if (scrollEl) scrollEl.addEventListener('scroll', updateThumbNav, { passive: true });
    window.addEventListener('resize', updateThumbNav);
    updateThumbNav();

    window.jxSetProductGalleryImage = function (src, alt, imageId) {
      if (!src) return;
      swapImage(src, alt || mainImage.alt, imageId || '');
      var match = Array.prototype.find.call(thumbs, function (thumb) {
        return thumb.getAttribute('data-image-id') === String(imageId);
      });
      if (match) setActiveThumb(match);
    };
  }

  function initProductVariantSelect() {
    var select = document.querySelector('[data-jx-variant-select]');
    var priceEl = document.getElementById('jx-product-price');
    if (!select) return;

    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      if (!option) return;

      if (priceEl && option.getAttribute('data-price')) {
        priceEl.textContent = option.getAttribute('data-price');
      }

      var imageSrc = option.getAttribute('data-image-src');
      var imageId = option.getAttribute('data-image-id');
      if (imageSrc && window.jxSetProductGalleryImage) {
        window.jxSetProductGalleryImage(imageSrc, null, imageId);
      }
    });
  }
})();
